var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApacheCouchdbIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.96 38.937c0 2.618-1.44 3.926-4.057 4.057H15.967c-2.618 0-4.057-1.3-4.057-4.057 0-2.618 1.44-3.926 4.057-4.057h32.065c2.618.13 3.926 1.44 3.926 4.057zm-3.926 6.02H15.967c-2.618 0-4.057 1.3-4.057 4.057 0 2.618 1.44 3.926 4.057 4.057h32.065c2.618 0 4.057-1.3 4.057-4.057-.13-2.748-1.44-4.057-4.057-4.057zm9.947-22.12c-2.618 0-4.057 1.3-4.057 3.926v22.12c0 2.618 1.44 3.926 4.057 4.057C61.906 52.8 64 48.883 64 40.9v-9.947c0-5.366-2.094-7.984-6.02-8.115zm-51.96 0C2.094 22.97 0 25.587 0 30.953V40.9c0 7.984 2.094 11.9 6.02 12.04 2.618 0 4.057-1.3 4.057-4.057V26.896c-.13-2.618-1.44-3.926-4.057-4.057zm51.96-1.963c0-6.675-3.534-9.816-9.947-9.947H15.967c-6.544.13-9.947 3.403-9.947 9.947 3.926 0 6.02 2.094 6.02 6.02s2.094 6.02 6.02 6.02h28c3.926 0 6.02-2.094 6.02-6.02-.13-4.057 2.094-5.9 5.9-6.02z",
    fill: "#e42528"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApacheCouchdbIcon);
export default __webpack_public_path__ + "static/media/apache_couchdb-icon.30d7dc8383a60bde32fcc55ee744c2dc.svg";
export { ForwardRef as ReactComponent };